import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=5ff4b73e&"
import script from "./addAdmin.vue?vue&type=script&lang=js&"
export * from "./addAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff4b73e')) {
      api.createRecord('5ff4b73e', component.options)
    } else {
      api.reload('5ff4b73e', component.options)
    }
    module.hot.accept("./addAdmin.vue?vue&type=template&id=5ff4b73e&", function () {
      api.rerender('5ff4b73e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/addAdmin.vue"
export default component.exports